import { render, staticRenderFns } from "./TransitionLinks.vue?vue&type=template&id=bf0d9a5e&scoped=true&"
import script from "./TransitionLinks.vue?vue&type=script&lang=js&"
export * from "./TransitionLinks.vue?vue&type=script&lang=js&"
import style0 from "./TransitionLinks.vue?vue&type=style&index=0&id=bf0d9a5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf0d9a5e",
  null
  
)

export default component.exports